import { usePlayerCard } from "@/context/PlayerCardContext";
import ChampBadge from "@/components/ChampBadge";

export default function PlayerName({ userId, name, className = "", testId }) {
  const { openPlayerCard } = usePlayerCard();
  if (!userId) return <span className={className}>{name}</span>;
  return (
    <button type="button" data-testid={testId || `player-name-${userId}`}
      onClick={(e) => { e.stopPropagation(); openPlayerCard(userId); }}
      className={`hover:text-pb-red hover:underline underline-offset-2 transition-colors text-left ${className}`}>
      {name}<ChampBadge userId={userId} />
    </button>
  );
}
